import React from 'react'
import Navbar from './user-pages/Navbar';
import Header from '../header/Header/Header';
import AllBids from './user-pages/AllBids';

const UserAccount = () => {
  return (
    <>
     <Navbar/>
    </>
  )
   

}

export default UserAccount;